































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { AppModule } from '@/store/modules/app';
import { getModule } from 'vuex-module-decorators';
import Scorm from '@/mixins/Scorm';
import { Id } from '@/types/Slide';
import Bookmark from '@/models/Bookmark';
import TableOfContentsType from '@/types/TableOfContents';
import { isSubString, isEmpty } from '@/utils/strings';

@Component
export default class TableOfContents extends mixins(Scorm) {
  @Prop() title !: string;
  search: string = '';
  searchInputValue: string = '';
  AppState = getModule(AppModule, this.$store);

  get toc(): TableOfContentsType {
    return this.AppState.tableOfContents;
  }

  public created() {
    this.init();
  }

  get getAlreadyVisitedPages() {
    return this.AppState.alreadyVisitedPagesHash;
  }

  get getCurrentSlide(): Id {
    return this.AppState.getCurrentSlide;
  }

  get isLockedForward(): boolean {
    return this.AppState.isLockedForward;
  }

  get isTotallyLocked(): boolean {
    return this.AppState.isTotallyLocked;
  }

  get filteredList() {
    return this.toc.slides.filter((item)=>this.isTocSearched(item.title));
  }

  private isDisabled(id: string, index: number): boolean {
    if (this.isTocActive(id)) return false;
    if (this.isLockedForward && index > this.AppState.getCurrentIndex) return true;
    return !this.getAlreadyVisitedPages[id] || this.isTotallyLocked;
  }

  private setSlide(id: Id, index: number) {
    if (this.isDisabled(id, index) || id == this.getCurrentSlide) return;
    this.AppState.goTo([id, index]);
    let bkmrkVersion = this.getBookmark().version;
    this.setBookmark(
      new Bookmark(
        this.AppState.currentIndex,
        this.AppState.getScore,
        this.AppState.getTotalScore,
        this.AppState.getBiggestIndex,
        bkmrkVersion
      )
    );
  }

  private isTocActive(id: string): boolean {
    return id == this.getCurrentSlide;
  }

  private isTocSearched(searchText: string): boolean {
    if (isEmpty(this.search)) return true;
    return isSubString(searchText, this.search);
  }

  public submit(){
    this.search = this.searchInputValue;
  }
  public reset(){
    this.search = '';
    this.searchInputValue = '';
  }
}
